import React from 'react';


export const title = (title) => {
  return (
    <title>{title}</title>
  );
};

export const metaTitles = (title) => {
  return [
    <meta key='title' name='title' content={title}/>,
    <meta key='og:title' property='og:title' content={title}/>,
    <meta key='twitter:title' name="twitter:title" content={title}/>,
  ]
};

export const metaDescriptions = (description) => {
  return [
    <meta key='description' name='description' content={description}/>,
    <meta key='og:description' property='og:description' content={description}/>,
    <meta key='twitter:description' name="twitter:description" content={description}/>,
  ]
};

export const metaImages = (image) => {
  return [
    <meta key='og:image' property="og:image" content={image}/>,
    <meta key='twitter:image' name="twitter:image" content={image}/>,
    <meta key='twitter:card' name="twitter:card" content="summary_large_image"/>,
  ]
};



// WEBPACK FOOTER //
// ./src/website-gridhaus/meta.js